import React from 'react';

export function SolotutorIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="30"
			viewBox="0 0 30 30"
			fill="none"
		>
			<path
				d="M14.0451 16.9922C13.1612 14.266 14.6546 11.3395 17.3808 10.4556C20.1069 9.57173 23.0334 11.0652 23.9173 13.7913C24.8012 16.5175 23.3078 19.444 20.5816 20.3279C17.8555 21.2118 14.929 19.7183 14.0451 16.9922Z"
				fill="white"
			/>
			<path
				d="M8.40859 19.9394C6.2234 18.0851 5.95509 14.8106 7.8093 12.6254C9.66351 10.4402 12.9381 10.1719 15.1233 12.0261C17.3085 13.8803 17.5768 17.1549 15.7226 19.3401C13.8684 21.5253 10.5938 21.7936 8.40859 19.9394Z"
				fill="white"
			/>
			<path
				d="M6.87917 9.87457L12.1583 8.06317C12.6754 7.88576 13.2383 8.16109 13.4157 8.67813L13.7616 9.68615C13.939 10.2032 13.6637 10.7662 13.1467 10.9436L7.8675 12.755C7.35046 12.9324 6.7875 12.657 6.61009 12.14L6.26421 11.132C6.0868 10.6149 6.36213 10.052 6.87917 9.87457Z"
				fill="#000A23"
			/>
			<path
				d="M18.279 6.04352L23.6975 7.38166C24.2282 7.51271 24.5522 8.04916 24.4211 8.57985L24.1656 9.61448C24.0345 10.1452 23.4981 10.4691 22.9674 10.3381L17.5489 8.99994C17.0182 8.86888 16.6943 8.33243 16.8253 7.80174L17.0808 6.76711C17.2119 6.23643 17.7483 5.91246 18.279 6.04352Z"
				fill="#000A23"
			/>
			<path
				d="M15.349 16.7406C14.9637 15.1842 15.913 13.6101 17.4695 13.2248C19.0259 12.8395 20.6 13.7889 20.9853 15.3453C21.3706 16.9018 20.4212 18.4758 18.8648 18.8611C17.3083 19.2464 15.7343 18.297 15.349 16.7406Z"
				fill="#000A23"
			/>
			<path
				d="M10.5193 18.6628C9.29674 17.6254 9.14662 15.7934 10.184 14.5708C11.2214 13.3482 13.0535 13.1981 14.2761 14.2355C15.4987 15.2729 15.6488 17.105 14.6114 18.3275C13.574 19.5501 11.7419 19.7002 10.5193 18.6628Z"
				fill="#000A23"
			/>
			<path
				d="M15.1727 23.8179C14.0819 23.7053 13.2478 22.8489 13.1221 21.8041C13.0881 21.5219 13.3472 21.3141 13.6299 21.3432L17.1883 21.7104C17.471 21.7395 17.6821 21.9959 17.5913 22.2652C17.2549 23.2623 16.2635 23.9304 15.1727 23.8179Z"
				fill="#27292C"
			/>
		</svg>
	);
}
